import React from 'react';
import { connect } from 'react-redux';
import * as usersActions from '../../store/users/actions';
import * as formsActions from '../../store/forms/actions';
import * as reducers from '../../store/reducers';

import Form from 'Components/Form';

class CreateUserAccount extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(fields, isFormValid) {
    if (isFormValid) {
      const { submitForm, formName, invitedUser, inviteToken } = this.props;
      const requestArgs = {};
      if (formName === 'acceptTeacherInvitation') {
        requestArgs.inviteToken = inviteToken;
      }
      submitForm(formName, formName, requestArgs);
    } else {
      const { enableFormReconciliationMode, formName } = this.props;
      enableFormReconciliationMode(formName, formName);
    }
  }

  render() {
    const { formName, invitedUser } = this.props;
    return (
      <Form
        type={formName}
        id={formName}
        initialFieldSettings={{
          username: { value: invitedUser.auth_info.username },
        }}
        submitHandler={(fields, isFormValid) =>
          this.handleSubmit(fields, isFormValid)
        }
        formStyle="acceptTeacherInvitation"
        messagePosition="page-top"
        submitButtonType="primary"
      />
    );
  }
}

export default connect(false, {
  ...usersActions,
  ...formsActions,
})(CreateUserAccount);
